// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quiz-base{height:calc(100vh - 80px)}@media(min-width:0)and (max-width:767px){.quiz-base{height:auto}}.quiz-base__headline{width:53%}@media(min-width:0)and (max-width:767px){.quiz-base__headline{width:100%}}.quiz-base__image{position:absolute;right:0;bottom:0;width:47%;height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;border-left:1px solid #000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
